import type { Invoice } from '@cocoonspace/sdk-js/types/invoice'
import { useEffect, useMemo, useState } from 'react'
import { AXIOS_INSTANCE } from '@cocoonspace/sdk-js/axios-client/use-custom-instance'
import { getUserToken } from '@cocoonspace/shared/libs/firebase'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { TableCell, TableRow } from '@cocoonspace/ui/components/table'
import { FileDownIcon } from 'lucide-react'
import { LocalizedLink as Link } from '~/components/localized-link'

import { useFormatPrice } from '~/hooks/use-format-price'
import { InvoiceStatus } from './invoice-status'

export const InvoiceTableRow = ({ invoice }: { invoice: Invoice }) => {
	const formatPrice = useFormatPrice()

	const [userToken, setUserToken] = useState<string | undefined>('')

	useEffect(() => {
		getUserToken().then(setUserToken)
	}, [])

	const isStatusVisible = useMemo(() => {
		return (
			// @ts-expect-error InvoiceStatus is not typed
			invoice.status !== 'issued' &&
			(invoice.status === 'voided' || invoice.payment_method === 'sepa_credit')
		)
	}, [invoice.status, invoice.payment_method])

	return (
		<TableRow className='divide-border/75 divide-x divide-dashed'>
			<TableCell>{dateTimeUtils(invoice.date).customFormat('date')}</TableCell>
			<TableCell>{invoice.ref}</TableCell>
			<TableCell>{invoice.title}</TableCell>

			<TableCell>
				{isStatusVisible && <InvoiceStatus status={invoice.status} />}
			</TableCell>

			<TableCell className='text-right'>
				<span className='flex items-baseline justify-end gap-1'>
					{formatPrice(invoice.amount, 'EUR')}
					<span className='text-xxs'>HT</span>
				</span>
			</TableCell>

			<TableCell className='text-right'>
				<span className='flex items-baseline justify-end gap-1'>
					{formatPrice(invoice.amount_with_vat, 'EUR')}
					<span className='text-xxs'>TTC</span>
				</span>
			</TableCell>

			<TableCell>
				<div className='flex items-center gap-2'>
					<Link
						href={`${AXIOS_INSTANCE.defaults.baseURL}/invoices/${invoice.ref}?token=${userToken}`}
						target='_blank'
					>
						<FileDownIcon size={20} />
					</Link>
				</div>
			</TableCell>
		</TableRow>
	)
}
